// extracted by mini-css-extract-plugin
export default {"wrapper":"C2-z","play":"D2-z"};